/**
 * Created by Bart Decorte
 * Date: 16/01/2020
 * Time: 16:36
 */
import Page from '../../pages/Page';
import Request from '../../utils/Request';
import {
  getCurrentSelectOptionLabel,
  renderSelectOptions,
  setEnabled as setFormElementEnabled,
  setSelectOptionByLabel,
} from '../../helpers/form_helper';
import { endpoints } from '../../utils/api';

export default class SlugGenerateIndex extends Page {
  constructor() {
    super();
    this.bindListeners();
    this.updateActiveTable();
  }

  bindListeners() {
    $('.js-table-id').on('change', (ev) => this.lTableIdChanged(ev));
    $('.js-btn-save').on('click', (ev) => this.lBtnSaveClicked(ev));
  }

  lTableIdChanged() {
    this.updateActiveTable();
  }

  lBtnSaveClicked(ev) {
    ev.preventDefault();
    this.submitForm();
    return false;
  }

  submitForm() {
    const $form = $('.js-main-form');
    $form.submit();
  }

  updateActiveTable() {
    const tableId = this.currentTableId();

    const fetch = async (tableId) => {
      const tableColumnsResponse = await this.fetchTableColumns(tableId);

      return {
        tableColumns: tableColumnsResponse.data,
      };
    };

    fetch(tableId).then((result) => {
      this.setTableColumnSelectOptions(result.tableColumns);
      return result;
    });
  }

  currentTableId() {
    const $elt = $('.js-table-id');
    return parseInt($elt.val());
  }

  fetchTableColumns(tableId) {
    const endpoint = endpoints.tableColumns(esign.info.websiteId, tableId);
    const request = new Request(endpoint, 'GET');
    return request.execute();
  }

  setTableColumnSelectOptions(columnData, restoreSelection = true) {
    const selector = '.js-table-column';
    let optionData = columnData.filter((column) => column.type_id == 16);
    optionData = optionData.map((column) => {
      return {
        value: column.id,
        name: `${column.name} (${column.column_name})`,
      };
    });

    const currentLabel = getCurrentSelectOptionLabel(selector);
    $(selector).html(renderSelectOptions(optionData));

    if (restoreSelection) {
      setSelectOptionByLabel(selector, currentLabel);
    }

    setFormElementEnabled(selector);
    return this;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/website-tools/slug-generate/SlugGenerateIndex.js